import TranslationListItemRequest from "./TranslationListItemRequest";

export default class TranslationListItem {
    constructor(
        public languageId: number,
        public value: string,
        public lookupTypeId: number | null,
        public languageCode:string,
        public objectId?: number,
    ) {}
        toTranslationListItemRequest(): TranslationListItemRequest {
            return new TranslationListItemRequest(this.languageId,this.value,this.lookupTypeId,this.objectId);
        }
}
